import React, { useEffect, useState } from "react";
import jsVectorMap from "jsvectormap";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/css/jsvectormap.min.css";
import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../../components/card/card.jsx";
import CardDashComponent from "../../components/card/CardDashComponent.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getSitesList } from "../../redux/action/sitesAction.js";
import { useLocation } from "react-router-dom";
import { getRoleModuleById } from "../../redux/action/roleModuleAction.js";
import findItem from "../../helperFindPath.js";

function Dashboard() {
  const { dataSitesList } = useSelector((state) => state.sites );
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth)
  const param = {
    token: user.access_token,
  }

  useEffect(() => {
    dispatch(getSitesList(param));
  }, []);
  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      // console.log(findPath)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }else{
        setDataObjPath('403')
      }
    }
  },[dataRoleModuleSidebar])

  if(dataObjPath === ''){
    return (
      null
    )
  }else if(dataObjPath === '403'){
    return (
      <div>
        <h2>403: Forbidden</h2>
        <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
      </div>
    )
  }else{
    return (
      <div>
        <div className="row">
          {dataSitesList &&
            dataSitesList.length > 0 &&
            dataSitesList.map((stat, index) => (
            <div className="col-md-4" style={{ paddingBottom: '10px'}}>
              <CardDashComponent title={stat.siteName} image={stat.image} id={stat.siteId}/>
            </div>)
            )}
        </div>
        {/* <CardConComponent /> */}
      </div>
    );
  }
}

export default Dashboard;
